import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Pages.css';

function Datenschutz({ name, address, city, postalCode, email }) {
  // Default values in case props aren't provided
  const fullName = name || "Julian Streibel";
  const contactEmail = email || "julian@streibel.xyz";
  const navigate = useNavigate();
  
  // Function to handle back button click
  const handleBack = () => {
    navigate('/'); // Navigate directly to home
  };
  
  return (
    <div className="legal-page">
      {/* Back button - with no border */}
      <button onClick={handleBack} className="back-button">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M19 12H5M12 19l-7-7 7-7"/>
        </svg>
        Zurück zur Startseite
      </button>
      
      <div className="legal-container">
        <h1>Datenschutzerklärung</h1>
        
        <div className="legal-section">
          <h2>1. Datenschutz auf einen Blick</h2>
          <br />
          <h3>Allgemeine Hinweise</h3>
          <p>Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Die Verarbeitung personenbezogener Daten erfolgt im Einklang mit den Bestimmungen der DSGVO und des österreichischen Datenschutzgesetzes (DSG).</p>
          
          <h3>Datenerfassung auf dieser Website</h3>
          <h4>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</h4>
          <p>Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Die Kontaktdaten können Sie dem Impressum dieser Website entnehmen.</p>
          
          <h3>Wie erfassen wir Ihre Daten?</h3>
          <p>Diese Website erfasst nur die technischen Daten, die für die Darstellung der Website notwendig sind. Eine Kontaktaufnahme ist ausschließlich per E-Mail möglich, wobei die von Ihnen angegebenen Daten nur für die Bearbeitung Ihrer Anfrage gespeichert und verwendet werden.</p>
          
          <h3>Wofür nutzen wir Ihre Daten?</h3>
          <p>Die erfassten Daten werden ausschließlich genutzt, um eine fehlerfreie Bereitstellung der Website zu gewährleisten.</p>
          
          <h3>Welche Rechte haben Sie bezüglich Ihrer Daten?</h3>
          <p>Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten. Sie haben außerdem ein Recht auf Berichtigung oder Löschung dieser Daten. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit widerrufen. Zudem haben Sie das Recht, unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Darüber hinaus steht Ihnen ein Beschwerderecht bei der österreichischen Datenschutzbehörde zu.</p>
        </div>
        
        <div className="legal-section">
          <h2>2. Verantwortlicher</h2>
          <p>Verantwortlicher im Sinne der DSGVO und des DSG ist:</p>
          <p>{fullName}</p>
          <p>E-Mail: {contactEmail}</p>
        </div>
        
        <div className="legal-section">
          <h2>3. Datenerfassung auf dieser Website</h2>
          <br />
          <h3>Server-Log-Dateien</h3>
          <p>Der Provider dieser Website erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, die Ihr Browser automatisch übermittelt. Dies sind:</p>
          <ul>
            <li>Browsertyp und Browserversion</li>
            <li>Verwendetes Betriebssystem</li>
            <li>Referrer URL</li>
            <li>Hostname des zugreifenden Rechners</li>
            <li>Uhrzeit der Serveranfrage</li>
            <li>IP-Adresse</li>
          </ul>
          <p>Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.</p>
          <p>Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der technisch fehlerfreien Darstellung und Optimierung seiner Website – hierzu müssen die Server-Log-Files erfasst werden.</p>
          
          <h3>Cookies</h3>
          <p>Diese Website verwendet keine Cookies für Analysen oder Tracking.</p>
          
          <h3>Anfragen per E-Mail</h3>
          <p>Wenn Sie mir per E-Mail Anfragen zukommen lassen, werden Ihre Angaben inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei mir gespeichert. Diese Daten gebe ich nicht ohne Ihre Einwilligung weiter.</p>
          <p>Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse) und meinem berechtigten Interesse an der effektiven Bearbeitung der an mich gerichteten Anfragen.</p>
          <p>Die von Ihnen an mich per E-Mail übersandten Daten verbleiben bei mir, bis Sie mich zur Löschung auffordern oder der Zweck für die Datenspeicherung entfällt (z. B. nach abgeschlossener Bearbeitung Ihrer Anfrage). Zwingende gesetzliche Bestimmungen – insbesondere gesetzliche Aufbewahrungsfristen – bleiben unberührt.</p>
        </div>
        
        <div className="legal-section">
          <h2>4. Ihre Rechte</h2>
          <br />
          
          <h3>Recht auf Auskunft, Löschung, Einschränkung</h3>
          <p>Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten können Sie sich jederzeit an mich wenden.</p>
          
          <h3>Beschwerde bei der zuständigen Aufsichtsbehörde</h3>
          <p>Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei einer Aufsichtsbehörde, insbesondere in dem Mitgliedstaat ihres gewöhnlichen Aufenthalts, ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes zu. Das Beschwerderecht besteht unbeschadet anderweitiger verwaltungsrechtlicher oder gerichtlicher Rechtsbehelfe.</p>
          <p>Die zuständige Aufsichtsbehörde in Österreich ist die Datenschutzbehörde (dsb.gv.at).</p>
        </div>
      </div>
    </div>
  );
}

export default Datenschutz; 